import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from "react";
import { Dialog, Slide, Divider, Button } from "@mui/material";
import PropTypes from "prop-types";
import CalendarHeader from "./CalendarComponent/CalendarHeader";
import MonthView from "./CalendarComponent/MonthView";
const Transition = React.forwardRef(function Transition(props, ref) {
    return _jsx(Slide, Object.assign({ direction: "up", ref: ref }, props));
});
function Calendar(props) {
    const { schedule, mediaName, mediaOptionName, toolName, units, unitsName, unitPrice, totalPrice, frequency, startDate, endDate } = props;
    const [open, setOpen] = useState(false);
    return (_jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ variant: "contained", color: "primary", onClick: () => setOpen(true) }, { children: "Open Calendar" })), _jsxs(Dialog, Object.assign({ open: open, TransitionComponent: Transition, maxWidth: "lg", onClose: () => setOpen(false), PaperProps: {
                    sx: {
                        borderRadius: "12px",
                        padding: "15px",
                    },
                } }, { children: [_jsx(CalendarHeader, { mediaName: mediaName, mediaOptionName: mediaOptionName, toolName: toolName, units: units, unitsName: unitsName, unitPrice: unitPrice, totalPrice: totalPrice, handleClose: () => setOpen(false) }), _jsx(Divider, {}), _jsx(MonthView, { schedule: schedule, mediaName: mediaName, mediaOptionName: mediaOptionName, toolName: toolName, frequency: frequency, startDate: startDate, endDate: endDate })] }))] }));
}
Calendar.propTypes = {
    schedule: PropTypes.array,
    mediaName: PropTypes.string,
    mediaOptionName: PropTypes.string,
    toolName: PropTypes.oneOf([
        "airport",
        "cinema",
        "digital",
        "hyperlocal",
        "influencer-marketing",
        "magazine",
        "newspaper",
        "nontraditional",
        "outdoor",
        "radio",
        "television",
    ]),
    units: PropTypes.number,
    unitsName: PropTypes.string,
    unitPrice: PropTypes.number,
    totalPrice: PropTypes.number,
    frequency: PropTypes.string,
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
};
export default Calendar;
